{
  "title": "如何正式提交作品",
  "description": "將已完成的作品正式送交競賽，並進入後續評審流程。",
  "headings": ["你會完成什麼", "操作前確認", "操作步驟", "完成後", "警告", "遇到問題"],
  "summary": "完成後，作品會正式送交競賽，並進入後續評審流程。",
  "prerequisites": [
    "所有必填欄位已完成",
    "檔案已上傳成功",
    "作品已標記為「就緒」",
    "尚未超過投稿截止時間（以競賽頁與作品繳交頁顯示的日期為準，是目前輪次的截止時間）"
  ],
  "steps": [
    {
      "title": "1. 確認作品內容",
      "description": "在「我的競賽 → 投稿 → 作品資料」確認標題、說明與檔案是否正確。"
    },
    {
      "title": "2. 確認狀態為「就緒」",
      "description": "若目前仍為「草稿」，先點選「標記為就緒」再繼續下一步。"
    },
    {
      "title": "3. 點選「正式提交」",
      "description": "確認提示內容後送出；送出後無法再回到上一步。"
    }
  ],
  "afterward": ["狀態變為「已提交」", "顯示正式提交時間", "編輯功能會被停用"],
  "warning": "正式提交後，作品可能無法再修改。請在送出前確認所有資料與檔案。",
  "nextSteps": "如果仍看得到「正式提交」卻無法點選，請查看「無法正式提交作品」。",
  "faq": [
    {
      "q": "上傳完成等於正式提交了嗎？",
      "a": "不是。上傳檔案只是暫存為草稿，必須另外標記為「就緒」並點選「正式提交」，作品才會真正送交競賽。"
    }
  ]
}
